export default {
  /* Please do not change the id-values here */
  items: [
    {
      id: 'SHARE',
      name: 'Aktien',
      color: '#FFBA49',
      strokeColor: '#D39631'
    },
    {
      id: 'SHARE_ETF',
      name: 'Aktien-ETF',
      color: '#E08A00',
      strokeColor: '#B76B00'
    },
    {
      id: 'CORPORATE_BONDS_ETF',
      name: 'Unternehmensanleihen-ETF',
      color: '#020E66',
      strokeColor: '#020E48'
    },
    {
      id: 'GOVERNMENT_BONDS_ETF',
      name: 'Staatsanleihen-ETF',
      color: '#6D76C5',
      strokeColor: '#4C5392'
    },
    {
      id: 'COMMODITIES_ETF',
      name: 'Rohstoffe',
      color: '#B6BBE2',
      strokeColor: '#8E92B1'
    },
    {
      id: 'CURRENCY_ETF',
      name: 'Kryptowährungen',
      color: '#B6BBE2',
      strokeColor: '#8E92B1'
    }
  ]
}
